import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import { InvoicePaymentStatusBadge } from "@/components/shared/badge/invoicePaymentStatus.badge";
import { InvoiceDto } from "@/types/api/api-types";
import FileIcon from "@/assets/icons/file.svg?react";
import EyeIcon from "@/assets/icons/eye.svg?react";
import TrashIcon from "@/assets/icons/trash.svg?react";
import { Dispatch, SetStateAction } from "react";

const columnHelper = createColumnHelper<InvoiceDto>();

export const useLitigeTableColumns = (
  displayDocument: (invoiceKey: string) => Promise<void>,
  setInvoiceToDeleteId: Dispatch<SetStateAction<string | undefined>>,
) => {
  const { t } = useTranslation("boClients");
  return [
    columnHelper.display({
      id: "invoice",
      header: t("invoicesLitigeTable.columns.litige"),
      cell: (info) => (
        <div className="flex flex-row items-center gap-4">
          <FileIcon width={20} height={20} />
          <span className="text-sm font-medium text-gray-900">
            {t("invoicesLitigeTable.litigeName", { invoiceId: info.row.original.invoiceId })}
          </span>
        </div>
      ),
    }),
    columnHelper.display({
      id: "status",
      header: t("invoicesLitigeTable.columns.status"),
      meta: `justify-center`,
      cell: (info) => <InvoicePaymentStatusBadge status={info.row.original.paymentStatus} />,
    }),
    columnHelper.display({
      id: "actions",
      header: "",
      cell: (info) => (
        <div className="flex flex-row items-center justify-center gap-3">
          <button
            className="h-fit w-fit rounded-full p-1 hover:bg-gray-200"
            onClick={() => displayDocument(info.row.original.invoiceKey)}
          >
            <EyeIcon width={20} height={20} color="#06F" />
          </button>
          {info.row.original.paymentStatus !== "PAID" && (
            <button
              className="h-fit w-fit rounded-full p-1 hover:bg-gray-200"
              onClick={() => setInvoiceToDeleteId(info.row.original.id)}
            >
              <TrashIcon width={20} height={20} color="#b00808" />
            </button>
          )}
        </div>
      ),
    }),
  ];
};
